let banner_swiper;

export default ({
    name : 'BannerBottom'
    , data () {
        return {}
    }
    , created () {
        this.code = 'banner_bottom';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    }
    , mounted () {
        this.bannerSwipe()
    }
    , computed : {
        bannerList () {
            let list = []
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) {
                if (bannerData.banner_image.default.length == 0) {
                    return []
                }
                bannerData.banner_image.value = bannerData.banner_image.default
            }
            let maxCnt = bannerData.banner_max_cnt.value;
            for (let key in bannerData.banner_image.value) {
                if (maxCnt <= key) { return; }
                let link = this.getBannerLink(bannerData.banner_link_type.value[key], bannerData.banner_link.value[key], bannerData.banner_link_id.value[key]);
                let item = {
                    'image' : bannerData.banner_image.value[key]
                    , 'link' : link.link
                    , 'target' : link.target
                }
                list[key] = item;
            }
            return list
        }
    }
    , methods : {
        isMultipleBanner () {
            if (this.isSetBasicData('banner_image') && this.basic.data.banner_image.value.length > 1) return true;
            return false;
        }
        , setBannerSwipe () {
			banner_swiper = new Swiper('.banner-slide', {
				slidesPerView: 'auto'
                , autoHeight : true
			});
        }
        , bannerSwipe () {
            if (this.isMultipleBanner()) {
                this.setBannerSwipe()
                return;
            } 
            if (typeof banner_swiper != 'undefined' && typeof banner_swiper.destroy == 'function') {
                banner_swiper.destroy();
                return;
            }
        }
    }
    , updated () {
        this.bannerSwipe()
    }
})
